export const routes = {
  HOME_PATH: "/",
  OFFERS_PATH: "/offers",
  CATEGORIES_PATH: "/categories/",
  CATEGORY_PATH: "/categories/[category]",
  STORE_PATH: "/categories/[category]/[id]",
  AUTH_PATH: "/auth/",
  SIGNIN_PATH: "/auth/signup",
  PRIVACY_PATH: "/privacy",
  YAWAKIT_PATH: "https://www.yawakit.com/",
  BLOG_PATH: "/blog/",
  FAQ_PATH: "/faq",
  REQUEST_DEMO: "/request-demo",
};
export const sections = {
  OFFERS_SECTION: "/#offers",
  CONTACT_SECTION: "/#contact",
};
